import { createSlice } from '@reduxjs/toolkit';
import {
  fetchQuestion,
  postFeedbackResponse,
  fetchFeedbackResponses,
} from './feedback.actions';
import { feedbackInitialState } from './feedback.initialState';

export const feedbackSlice = createSlice({
  name: 'feedbackSlice',
  initialState: feedbackInitialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchQuestion.fulfilled, (state, action) => {
        state.question.data = action.payload;
        state.question.loading = false;
        state.question.error = null;
      })
      .addCase(fetchQuestion.pending, (state) => {
        state.question.loading = true;
        state.question.error = null;
      })
      .addCase(fetchQuestion.rejected, (state, action) => {
        state.question.loading = false;
        state.question.error = action.payload;
      })
      .addCase(postFeedbackResponse.fulfilled, (state) => {
        state.postFeedbackRequest.loading = false;
        state.postFeedbackRequest.error = null;
      })
      .addCase(postFeedbackResponse.pending, (state) => {
        state.postFeedbackRequest.loading = true;
        state.postFeedbackRequest.error = null;
      })
      .addCase(postFeedbackResponse.rejected, (state, action) => {
        state.postFeedbackRequest.loading = false;
        state.postFeedbackRequest.error = action.payload;
      })
      .addCase(fetchFeedbackResponses.fulfilled, (state, action) => {
        state.feedbackResponses.data = action.payload;
        state.feedbackResponses.loading = false;
        state.feedbackResponses.error = null;
      })
      .addCase(fetchFeedbackResponses.pending, (state) => {
        state.feedbackResponses.loading = true;
        state.feedbackResponses.error = null;
      })
      .addCase(fetchFeedbackResponses.rejected, (state, action) => {
        state.feedbackResponses.loading = false;
        state.feedbackResponses.error = action.payload;
      });
  },
});
